import React, { useEffect, useState } from "react";

import { Image } from "semantic-ui-react";

import "./CheckInCommon.css";

const SCREEN_WIDTH = 1440;
const SCREEN_HEIGHT = 1024;
const BASE_FONT_SIZE = 16;

// Scale html root font-size with the viewport so every rem keeps design proportions.
// Restored on unmount so other pages aren't affected.
const useViewportScaledFontSize = () => {
  useEffect(() => {
    const original = document.documentElement.style.fontSize;
    const update = () => {
      const scale = Math.min(
        window.innerWidth / SCREEN_WIDTH,
        window.innerHeight / SCREEN_HEIGHT,
      );
      document.documentElement.style.fontSize = `${BASE_FONT_SIZE * scale}px`;
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      document.documentElement.style.fontSize = original;
      window.removeEventListener("resize", update);
    };
  }, []);
};

const LOGO = "/static/images/checkin/logo-mehealth.png";

export const MeHealthLogo = (props: { className?: string; style?: React.CSSProperties }) => (
  <Image
    src={LOGO}
    alt="MeHealth"
    className={props.className || "checkin-page-logo"}
    style={props.style}
  />
);

export const MeHealthClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const timeString = currentTime.toLocaleTimeString("th-TH", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const dateString = currentTime.toLocaleDateString("th-TH", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <div className="checkin-page-clock">
      <div className="checkin-page-time">{timeString}</div>
      <div style={{ fontSize: "1rem", color: "#666666", marginTop: "0.25rem" }}>{dateString}</div>
    </div>
  );
};

export const MeHealthFooter = (props: { className?: string; style?: React.CSSProperties }) => (
  <div className={props.className || "checkin-page-footer"} style={props.style}>
    รักสุขภาพ ต้องเข้าใจร่างกาย... Love Health - Understand Your body
  </div>
);

type CheckInLayoutProps = {
  children: React.ReactNode;
  headerTitle?: React.ReactNode;
};

const CheckInLayout = (props: CheckInLayoutProps) => {
  useViewportScaledFontSize();

  return (
    <div className="checkin-page">
      <div className="checkin-page-header">
        <MeHealthLogo />
        {props.headerTitle && <div className="checkin-page-title">{props.headerTitle}</div>}
        <MeHealthClock />
      </div>

      {props.children}

      <MeHealthFooter />
    </div>
  );
};

export default CheckInLayout;
